/**
 * exit Receipt
 */

// React
import React, {useEffect} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../../redux/reducers';
import {getOrdersAction, getOrderWithIdAction} from '../../orders/actions';

// Selector
import {createStructuredSelector} from 'reselect';

//UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';

import {WrapperReceipt} from './style';
import jMoment from 'moment-jalaali';
import Barcode from 'react-barcode';

// Type
import {SelectorProps, Props} from '../interfaces';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError, makeSelectOrdersList,
} from '../../orders/selectors';
import {Payload} from '../../orders/interfaces';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function ExitReceipt(props: Props) {
  const classes = useStyles();

  useEffect(() => {
    props.ordersDispatch({
      deliveryType: {in: 'POST,EXPRESS_POST,SPECIAL_POST'},
      postOrderStatus: {in: 'QUEUE,DONE'},
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.orders[0]?.id) {
      window.print();
    }
  }, [props.orders]);

  const {orders} = props;
  return (
    <WrapperReceipt className={classes.root}>
      {
        orders.map((order: any) => (
          <div className="page" key={order.id}>
            <div className="next-page">
              <header className="header">
                <h3>{order?.partnerName}</h3>
                <div>
                  <div className="info">
                    <div className="date">
                      {order?.deliveryDate &&
                      jMoment(order.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}
                    </div>
                    <div className="time">
                      بازه{' '}
                      {order?.deliveryStartTime &&
                      jMoment(order.deliveryStartTime, 'HH:mm:ss')
                        .locale('fa')
                        .format('HH')}{' '}
                      الی{' '}
                      {order?.deliveryEndTime &&
                      jMoment(order.deliveryEndTime, 'HH:mm:ss')
                        .locale('fa')
                        .format('HH')}
                    </div>
                    <p className="pay-type">پرداخت آنلاین</p>
                  </div>
                  <div className="barcode">
                    <p className="route">
                      {order?.customerProvince} - {order?.customerCity}
                    </p>
                    <Barcode
                      fontSize={12}
                      value={order?.id}
                      height={'30px'}
                      background="#f1f0f0"
                    />
                  </div>
                </div>
              </header>
              <main>
                <div className="info-box">
                  <div className="title">گیرنده</div>
                  <div className="box">
                    <div>
                <span>
                  نام : <span className="userInfo">{order?.customerName}</span>
                </span>
                      <span>
                  تلفن :{' '}
                        <span dir="ltr" className="userInfo">
                    {order?.customerPhoneNumber}
                  </span>
                </span>
                      <span>
                  کدپستی :{' '}
                        <span className="userInfo">{order?.customerZipCode}</span>
                </span>
                    </div>
                    <p>
                      آدرس:
                      <span className="userInfo">{order?.customerAddress}</span>
                    </p>
                  </div>
                </div>
                <div className="info-box deliver">
                  <div className="title">فرستنده</div>
                  <div className="box">
                    <div>
                <span>
                  نام : <span className="userInfo">{order?.partnerName}</span>
                </span>
                      <span>
                  تلفن : <span className="userInfo">{order?.partnerName}</span>
                </span>
                      <span>
                  کدپستی : <span className="userInfo">1746834813</span>
                </span>
                    </div>
                    <p>
                      آدرس:
                      <span className="userInfo">
                  خیابان دماوند بعد از پل شهید سردار سلیمانی کندرو داتیس خودرو
                  پلاک ۲۶۰
                </span>
                    </p>
                  </div>
                </div>
                <div className="info-box description">
                  <div className="title">عملیات پستی</div>
                  <div className="box">
                    <div className="barcode">
                      <Barcode
                        fontSize={12}
                        value={order?.barcode}
                        height={'30px'}
                        background="#f1f0f0"
                      />
                    </div>
                  </div>
                </div>
                <div className="footer">
                  <img src="/logo-dark.svg" alt="ronad" />
                  <div>
                    <p>پردازش و ارسال توسط خدمات هوشمند لجستیک روناد</p>
                    <p>www.ronad.ir</p>
                  </div>
                </div>
              </main>
            </div>

          </div>
          )
        )
      }
    </WrapperReceipt>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  orders: makeSelectOrdersList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
// @ts-ignore
export default compose(withConnect)(ExitReceipt);
